import { cn } from '../../lib/cn.ts';

export interface TranscriptBubbleProps {
  speaker: 'guest' | 'hostesa';
  speakerLabel: string;
  lang?: string;
  text: string;
  className?: string;
  'data-testid'?: string;
}

/**
 * TranscriptBubble — one turn in a live conversation. Guest turns sit on warm
 * canvas (left); Hostesa turns are charcoal (right). The speaker label is mono.
 */
export function TranscriptBubble({
  speaker,
  speakerLabel,
  lang,
  text,
  className,
  'data-testid': testId,
}: TranscriptBubbleProps) {
  const isGuest = speaker === 'guest';
  return (
    <div
      data-testid={testId}
      className={cn('flex w-full flex-col gap-1', isGuest ? 'items-start' : 'items-end', className)}
    >
      <span className="font-[var(--font-mono)] text-[10px] uppercase tracking-widest text-[var(--color-stone-mid)]">
        {speakerLabel}
        {lang ? ` · ${lang}` : ''}
      </span>
      <p
        className={cn(
          'max-w-[85%] rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed',
          isGuest
            ? 'rounded-tl-sm bg-[var(--color-canvas)] text-[var(--color-charcoal)]'
            : 'rounded-tr-sm bg-[var(--color-charcoal)] text-[var(--color-alabaster)]',
        )}
      >
        {text}
      </p>
    </div>
  );
}
